/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Other9Inputs */

const en__field_enum_tuda_other9 = /** @type {(inputs: _Field_Enum_Tuda_Other9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_tuda_other9 = /** @type {(inputs: _Field_Enum_Tuda_Other9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiger Fachbereich`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Tuda_Other9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_other9 = /** @type {((inputs?: _Field_Enum_Tuda_Other9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Other9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_other9(inputs)
	return de__field_enum_tuda_other9(inputs)
});
export { _field_enum_tuda_other9 as "_field_enum_TUDA_OTHER" }